/* eslint-disable radix */
/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { Card, CardBody } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { editPlanValidationSchema } from 'pages/Addons/constants';
import { UPDATE_SUBSCRIPTION_PLAN } from 'pages/SubscriptionPlans/subscriptionPlanGraphQL';
import ErrorBoundary from 'components/common/ErrorBoundary';
import EditPlansForm from './components/EditPlansForm';

const EditPlans = ({ drawerToggle, currentRow, refetch = () => {} }) => {
  const [updateSubscriptionPlan] = useMutation(UPDATE_SUBSCRIPTION_PLAN, {
    onCompleted: ({ updateSubscriptionPlan }) => {
      toast.success(updateSubscriptionPlan?.message);
      drawerToggle();
      refetch();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ extensions }) => {
        toast.error(extensions?.errorMessage);
        drawerToggle();
      });
    },
  });

  const handleSubmit = async (values) => {
    const obj = { ...values.plans?.[0] };
    delete obj.createdAt;
    delete obj.updatedAt;
    delete obj.__typename;

    try {
      await updateSubscriptionPlan({
        variables: {
          updateInput: {
            ...obj,
            discountedAmount: parseFloat(obj?.discountedAmount),
          },
          subscriptionPlanPriceHistoryInputDTO: {
            subscriptionPlan: currentRow?.id,
            newPrice: parseFloat(obj?.price),
          },
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <ErrorBoundary>
        <Card className="border-0 card-box ">
          <CardBody>
            <Formik
              enableReinitialize
              validationSchema={editPlanValidationSchema}
              initialValues={{
                plans: [currentRow],
              }}
              onSubmit={handleSubmit}
              children={(props) => {
                return <EditPlansForm {...props} drawerToggle={drawerToggle} />;
              }}
            />
          </CardBody>
        </Card>
      </ErrorBoundary>
    </div>
  );
};

export default EditPlans;
